import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';
import { AppModels, AppState, ContactAttrs, RelatedContactAttrs, brandNewContact, companySelector, contactSlice, hasErrors, jsonDelete, newRelatedContact, projectSelector, relatedContactSlice, saveModel, selectProjectContacts, selectcompanyContacts, splitContactName } from 'cdx-common';
import React from 'react';
import { useSelector } from 'react-redux';
import { useToaster } from '../../libraries/Toaster';
import { appStore } from '../../store';
import { SuperSearchInput } from '../SuperSearchInput';
import { ProjectContactItem } from './ProjectContactItem';

interface ProjectCompanyContactList {
    onProject: RelatedContactAttrs[],
    outOfProject: RelatedContactAttrs[];
}



export const ProjectContacts = () => {
    const project = useSelector((state: AppState) => projectSelector.selectById(state, state.projectPage.project.id));
    const projectContacts = useSelector((state: AppState) => selectProjectContacts(state, state.projectPage.project.id));
    const companyContacts = useSelector((state: AppState) => project?.customerCompanyId ? selectcompanyContacts(state, project.customerCompanyId) : []);
    const company = useSelector((state: AppState) => project?.customerCompanyId ? companySelector.selectById(state, project.customerCompanyId) : undefined);
    const { toast } = useToaster();
    const [contacts, setContacts] = React.useState<ProjectCompanyContactList>({ onProject: [], outOfProject: [] });
    const [editContacts, setEditContacts] = React.useState(false);

    React.useEffect(() => {

        setContacts(companyContacts.reduce((acc: ProjectCompanyContactList, curr: RelatedContactAttrs) => {
            if (!projectContacts.find(p => p.contactId === curr.contactId)) {
                acc.outOfProject.push(curr);
            }
            return acc;
        }, { onProject: [...projectContacts], outOfProject: [] }));

    }, [projectContacts, companyContacts]);

    if (!project) return <></>;

    const onNewContactSelected = async (_type: AppModels, _id: ModelId, data: ContactAttrs) => {
        createProjectContact(data);
    };
    const createProjectContact = async (contact: ContactAttrs) => {
        const response = await saveModel(AppModels.relatedContacts, {
            ...newRelatedContact,
            ...contact,
            contactId: contact.id,
            id: '0',
            relatedType: AppModels.projects,
            relatedId: project.id
        });
        if (!hasErrors(response)) {
            appStore.dispatch(relatedContactSlice.actions.upsertOne(response));
            toast.success("Contact ajouté");
        } else {
            toast.error("Impossible d'ajouter ce contact au projet");
        }
    };
    const onCreateContact = async (name: string) => {

        const newContact = await saveModel(AppModels.contacts, {
            ...brandNewContact,
            ...splitContactName(name)
        });
        if (!hasErrors(newContact)) {
            appStore.dispatch(contactSlice.actions.upsertOne(newContact));
            createProjectContact(newContact);
        } else {
            toast.error("Impossible de créer le contact");
        }
    };
    const onDeleteContact = async (rc: RelatedContactAttrs) => {
        const response = await jsonDelete('/data/relatedContacts/' + rc.id);
        if (response) {
            appStore.dispatch(relatedContactSlice.actions.removeOne(rc.id));
        }
    };

    return <><Grid container spacing={2}>
        <Grid item xs={12}>
            <Stack spacing={{ xs: 1, sm: 1 }} direction="row" useFlexGap flexWrap="wrap">
                {contacts.onProject.map(rc => <ProjectContactItem key={rc.id} onDelete={editContacts ? () => {
                    onDeleteContact(rc);
                } : undefined} relatedContact={rc} />)}
            </Stack>
        </Grid>
        <Grid item xs={12}>
            <Accordion expanded={editContacts} onChange={() => setEditContacts(p => !p)}>
                <AccordionSummary
                    aria-controls="panel1-content"
                    id="panel1-header"
                >
                    <Typography>Ajouter ou retirer un intervenant</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Stack spacing={{ xs: 1, sm: 1 }} direction="row" useFlexGap flexWrap="wrap">
                        {contacts.outOfProject.map(rc => <ProjectContactItem key={rc.id} relatedContact={rc} notInProjectId={project.id} />)}
                    </Stack>
                    <Box sx={{ paddingTop: 1 }}>
                        <SuperSearchInput
                            textfieldProps={{
                                size: 'small',
                                label: 'Nouveau contact' + (company ? ' ' + company.name : ''),
                                placeholder: 'Prénom et nom'
                            }}
                            filter={[AppModels.contacts]}
                            onItemSelected={onNewContactSelected}
                            onCreate={onCreateContact}
                            clearOnSelect
                        />
                    </Box>
                </AccordionDetails>
            </Accordion>
        </Grid>
    </Grid></>;

};
